import styles from './BackCrumb.module.css';

export type BackCrumbProps = { label: string; onBack: () => void };

export const BackCrumb = ({ label, onBack }: BackCrumbProps) => (
  <button type="button" className={styles['crumb']} onClick={onBack}>
    {label}
  </button>
);
